
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linked_in",
      function () {
        return require("private-next-pages/linked_in/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linked_in"])
      });
    }
  